import { BaseDTO } from '../global/base.dto';

export class DashboardNotificationHistoryDTO extends BaseDTO {

    body: string;

    entity: number;

    event: number;

    type: number;

}
